<main
  class="flex flex-col min-h-screen gap-6 md:px-4 lg:container xl:px-20 lg:mx-auto md:pt-6 md:pb-20"
>
  <div class="w-full px-4 md:px-6 md:py-0">
    <app-header />
  </div>

  <section class="flex md:flex-row flex-col w-full gap-[60px]">
    <div class="w-full md:max-w-[256px] flex flex-col gap-3 md:px-0 px-4">
      <div
        class="flex flex-col items-center justify-center gap-6 border rounded-[32px] border-neutral-200 p-5 min-h-[256px] min-w-[256px]"
      >
        @if (user(); as user) {
        <app-profile-image size="lg" [src]="user.profileImage || ''" />

        <div class="flex flex-col items-center w-full gap-2">
          <p class="text-xl font-semibold text-neutral-900">
            {{ user.nickname }}
          </p>

          <div class="flex items-center gap-2">
            <img src="icons/kakaologo.svg" class="size-5" />
            <p class="text-neutral-600">{{ user.email }}</p>
          </div>
        </div>
        }
      </div>
      <div class="flex flex-col gap-3">
        @for (option of options; track option) {
        <button
          (click)="handleTabChange(option)"
          class="flex items-center justify-between w-full p-5 font-semibold transition-colors cursor-pointer select-none rounded-xl"
          [ngClass]="
                      tab() === option
                        ? 'md:text-primary md:bg-[#FFF7ED] text-neutral-900 '
                        : 'text-neutral-900 bg-white md:hover:bg-gray-100'
                    "
        >
          <div class="flex items-center gap-2.5">
            <app-icon
              [name]="getIconName(option)"
              [ngClass]="tab() === option ? 'md:text-primary md:bg-[#FFF7ED] text-neutral-900' : 'text-neutral-900'"
            />
            {{ option }}
          </div>
        </button>
        }
        <button
          (click)="logout()"
          class="w-full p-5 font-semibold transition-colors cursor-pointer select-none rounded-xl"
        >
          <div class="flex items-center gap-2.5">
            <app-icon name="ic:outline-logout" />
            <p class="text-neutral-900">로그아웃</p>
          </div>
        </button>
      </div>
    </div>
    <div class="w-full">
      <router-outlet />
    </div>
  </section>
</main>
